module.exports = __webpack_public_path__ + "img/pt.ce5cef09.svg";